import PostsList from './_PostsList';

export default PostsList;
